module.exports = __webpack_public_path__ + "img/54.811cac86.jpg";